import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    UPDATE_CPD_POINT_STATUS: (adminTaskId, userCpdPointId, cpdPointStatus) => ({ adminTaskId, userCpdPointId, cpdPointStatus }),
    API: {
      UPDATE_CPD_POINT_STATUS: apiResourceActionCreator('cpdPoint')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.put(`${API_ENDPOINT}/updateCpdPointStatus`, authToken, payload, actions.admin.api.updateCpdPointStatus);

function* updateCpdPointStatus(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'updateCpdPointStatus',
  action: actions,
  sagas: updateCpdPointStatus,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUploadingCPD: true
    }),
    success: (state, action) => ({
      ...state,
      isUploadingCPD: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUploadingCPD: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/updateCpdPointStatus.js